import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { Config } from 'ionic-angular';

@Injectable()
export class GalleryService {

  private serverUrl : string;

  constructor(private http: Http, configuration: Config) {
    this.serverUrl = configuration.get('backendUrl');
  }

  public findImagePaths(imageFolder : string) : Observable<Array<String>> {
    return Observable.create(observer => {
	  var self = this;
	  this.http.get(this.serverUrl+'/api/images/'+imageFolder)
        .map(res => res.json())
		.map(data => {
			data.forEach(function(part, index, theArray) {
				theArray[index] = self.serverUrl + '/image/' + part;
			});
			return data;
		})
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(error);
        }
      );
    });
  }

  private handleError(error) {
    console.error(error);
    return Observable.throw((error.status === 404 ? error.text() : error.json().error) || 'Server error while reading event data');
  }
}


// WEBPACK FOOTER //
// ./src/providers/gallery-service/gallery-service.ts